import videojs from "video.js";
import Event from "../event";

const Component = videojs.getComponent("Component");

class RecordIndicator extends Component {
  /**
   * The constructor function for the class.
   *
   * @private
   * @param {(videojs.Player|Object)} player - Video.js player instance.
   * @param {Object} options - Player options.
   */
  constructor(player, options) {
    super(player, options);

    this.enable();
  }

  /**
   * Create the `RecordIndicator`s DOM element.
   *
   * @return {Element}
   *         The dom element that gets created.
   */
  createEl() {
    const { createEl } = videojs.dom;

    const wrap = createEl("div", {
      className: "vjs-record-indicator__wrap",
      innerHTML: `<span>${this.localize("REC")}</span><i></i>`
    });

    return createEl(
      "div",
      {
        className: "vjs-record-indicator vjs-control"
      },
      {},
      wrap
    );
  }

  /**
   * Enable event handlers.
   */
  enable() {
    this.on(this.player_, Event.START_RECORD, this.show);
    this.on(this.player_, Event.STOP_RECORD, this.hide);
  }

  /**
   * Disable event handlers.
   */
  disable() {
    this.off(this.player_, Event.START_RECORD, this.show);
    this.off(this.player_, Event.STOP_RECORD, this.hide);
  }

  /**
   * Show the `RecordIndicator` element if it is hidden by removing the
   * 'vjs-hidden' class name from it.
   */
  show() {
    if (this.layoutExclude && this.layoutExclude === true) {
      // ignore
      return;
    }
    super.show();
  }
}

Component.registerComponent("RecordIndicator", RecordIndicator);

export default RecordIndicator;
